<template>
  <div
    class="video-attachment-wrapper"
    :class="[{ 'is-hide-info': hideInfo }]"
  >
    <a
      v-if="!file.deleted"
      id="videoPath"
      :data-fancybox="useSharedFancybox ? fancyboxData : null"
      :video-data-fancybox="useSharedFancybox ? null : fancyboxData"
      :data-caption="file.name"
      :data-file-metadata-id="file.id"
      :href="videoPath"
      :data-type="useSharedFancybox ? 'html5video' : 'video'"
      class="video-attachment__link"
    >
      <div class="video-attachment">
        <div class="video-attachment__video ready-to-play">
          <video
            class="video-attachment__video"
            :src="videoPath"
          />
        </div>

        <div
          v-if="!hideInfo"
          class="video-attachment__info"
        >
          <BaseSubHeading
            color="monochrome-07"
            weight="400"
            size="large"
            class="video-attachment__title"
          >
            {{ file.name }}
          </BaseSubHeading>
          <BaseSubHeading
            size="extra-small"
            weight="500"
            color="monochrome-05"
            darkColor="monochrome-04"
            class="video-attachment__size"
          >
            {{ formatBytes(file.size.toString()) }}
          </BaseSubHeading>
        </div>
      </div>
    </a>
    <div
      v-else
      class="video-attachment video-attachment_deleted"
    >
      <div class="video-attachment__video">
        <div
          v-if="!hideInfo"
          class="video-attachment_deleted__name-wrapper"
        >
          <icon
            data="@icon/play-not-found.svg"
            width="var(--icon-24)"
            height="var(--icon-24)"
            color="var(--monochrome05to04)"
          />
        </div>
        <template v-else>
          <div class="video-attachment_deleted__name-wrapper">
            <div class="custom-file-simplified__icon">
              <icon
                data="@icon/play-not-found.svg"
                width="var(--icon-24)"
                height="var(--icon-24)"
                color="var(--monochrome05to04)"
              />
            </div>
            <BaseSubHeading
              weight="400"
              class="video-attachment_deleted__name"
              size="medium"
            >
              {{ file.name }}
            </BaseSubHeading>
          </div>
          <BaseSubHeading
            weight="500"
            size="extra-small"
            class="video-attachment_deleted__info"
            color="monochrome-05"
            darkColor="monochrome-04"
          >
            Deleted by {{ file.deletedBy?.fullName }}
          </BaseSubHeading>
        </template>
      </div>

      <div
        v-if="!hideInfo"
        class="video-attachment__info"
      >
        <BaseSubHeading
          color="monochrome-07"
          weight="400"
          size="large"
          class="video-attachment__title"
        >
          {{ file.name }}
        </BaseSubHeading>
        <BaseSubHeading
          size="extra-small"
          weight="500"
          color="monochrome-05"
          darkColor="monochrome-04"
          class="video-attachment_deleted__initiator"
        >
          Deleted by {{ file.deletedBy?.fullName }}
        </BaseSubHeading>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import BaseSubHeading from "@/components/Base/BaseSubHeading.vue"

import formatBytes from "@/helpers/formatBytes"
import { FileMetaData } from "@/models"
import { bindFancyBox } from "@/utils/fancyboxHelper"
import { attachSlideStreamRecovery } from "@/utils/videoStreamRecovery"

@Options({
  name: "VideoAttachmentItem",
  components: { BaseSubHeading }
})
export default class VideoAttachmentItem extends Vue {
  @Prop({
    required: true
  })
  file: FileMetaData

  @Prop({
    default: ""
  })
  videoPath: string

  @Prop({
    require: true
  })
  fancyboxData: string

  @Prop({
    default: false
  })
  hidePoster: boolean

  @Prop({
    default: false
  })
  hideInfo: boolean

  @Prop({
    default: false
  })
  useSharedFancybox: boolean

  options = {
    Carousel: {
      infinite: false
    }
  }

  mounted() {
    if (this.file.deleted || this.useSharedFancybox) {
      return
    }
    bindFancyBox({
      id: "[video-data-fancybox]",
      options: {
        Toolbar: {
          autoEnable: false
        },
        on: {
          done: (fancybox, slide) => {
            if (slide.type === "video") {
              if (slide.$content) {
                slide.$content.innerHTML = `<video src="${slide.src}" controls> </video>`
                attachSlideStreamRecovery(slide)
              }
            }
          },
          "Carousel.change": () => {
            const videos = document.querySelectorAll("video")
            videos.forEach(video => {
              video.pause()
            })
          },
          closing: () => {
            this.$emit("closeVideo")
          }
        }
      }
    })
  }

  formatBytes(value: string) {
    return formatBytes(value)
  }
}
</script>
